'use client'

import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Spinner } from './spinner'

import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
interface OverlayLoadingProps {
  show: boolean
  text?: string
}

export default function OverlayLoading({ show, text }: OverlayLoadingProps) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/40 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="flex flex-col items-center gap-2"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <Spinner className="h-6 w-6 text-primary-500" />
            <span className="text-sm text-[#2D2E32]">{text ?? t('common.processing')}</span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
